import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";




@Component({
  selector: 'app-direcciones',
  templateUrl: './direcciones.component.html',
  styleUrls: ['./direcciones.component.css']
})
export class DireccionesComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DireccionesComponent>) { }

  ngOnInit() {
  }

  principal = [
    { id: '', name: "Ninguno" },
    { id: 'AV', name: "Avenida" },
    { id: 'CL', name: "Calle" },
    { id: 'AC', name: "Avenida Calle" },
    { id: 'AK', name: "Avenida Carrera" },
    { id: 'KR', name: "Carrera" },
    { id: 'DG', name: "Diagonal" },
    { id: 'TV', name: "Transversal" },
    { id: 'KM', name: "Kilometro" },
  ];

  complemento = [
    { id: '', name: "Ninguno" },
    { id: 'MZ', name: "Manzana" },
    { id: 'SMZ', name: "Supermanzana" },
    { id: 'TR', name: "Torre" },
    { id: 'OF', name: "Oficina" }
  ];

  complemento2 = [
    { id: '', name: "Ninguno" },
    { id: 'BG', name: "Bodega" },
    { id: 'CA', name: "Casa" },
    { id: 'AP', name: "Apartamento" },
    { id: 'LT', name: "Lote" },
  ];


  selectedPrincipal = this.principal[0];
  selectedCompleme1 = this.complemento[0];
  selectedCompleme2 = this.complemento2[0];
  numPrincipal = '';
  numPrincipal2 = '';
  numComplemen1 = '';
  numComplemen2 = '';



  save(value) {
    this.dialogRef.close({ dir: value }) // send data to parent component
  }
  cerrar() {
    this.dialogRef.close({ dir: false });

  }


}
